export const formatRecoveryCodesForCopy = (codes: readonly string[]): string => codes.join("\n");

export const buildRecoveryCodesFileContent = (codes: readonly string[]): string =>
	`${formatRecoveryCodesForCopy(codes)}\n`;
